import Map from "google-map-react";
import { Modal } from "react-bootstrap";
import React from "react";
import CurrentLocation from "shared/assets/images/svg/deliv_gr.svg";
import closeIcon from "shared/assets/images/svg/close_dialog.svg";
import { LoadOptions } from "devextreme/data";
import _ from "lodash";
import { useRecoilState } from "recoil";
import { balanceFilterAtom } from "customer/orders/myBalance/my-balance.service";
import dxDataGrid from "devextreme/ui/data_grid";
import { Workbook } from "exceljs";
import saveAs from "file-saver";
import JsPdf from "jspdf";
import { toast } from "react-toastify";
import { exportDataGrid } from "devextreme/excel_exporter";
import { mapFilters } from "../../helpers/client";


const Marker = ({ icon = CurrentLocation }: any) => <img className="map-icon" src={icon} alt="dexef-logo" />;

interface LocationFieldProps {
  show: boolean;
  onHide: () => void;
  onChoose: (location: Map.ClickEventValue) => void;
}

export interface Params {
  skipCount?: number;
  maxResultCount?: number;
  searchTerm?: string;
  filter?: string;
  loadData?: any;
}

export function LocationField({ show, onHide, onChoose }: LocationFieldProps) {
  const [location, setLocation] = React.useState<Map.ClickEventValue>();
  return (
    <Modal show={show}>
      <Modal.Header>
        <h2>Choose Location</h2>
        <button onClick={onHide}>
          <img src={closeIcon} alt="close-button" />
        </button>
      </Modal.Header>
      <div style={{ height: 500 }}>
        <Map
          zoom={18}
          center={{ lng: 39, lat: 36 }}
          bootstrapURLKeys={{ key: "AIzaSyB_VKEUIGOwssXqLuDQNxd22liPU-j-Uho" }}
          onClick={l => {
            setLocation(l);
            onChoose(l);
          }}
        >
          <Marker lat={location?.lat} lng={location?.lng} />
        </Map>
      </div>
    </Modal>
  );
}

export function loadFn(
  loadService: (params: Params) => Promise<{ response: any; error: any }>,
  loadData: any = {}
) {
  return async (options: LoadOptions) => {
    const filter = mapFilters(options.filter);

    const params: Params = {
      filter,
      skipCount: options.skip ?? 0,
      maxResultCount: options.take ?? 0,
      ...loadData
    };

    const { response, error } =
      typeof loadService === "function"
        ? await loadService(params)
        : { response: null, error: "provide get service" };

    if (error) throw error;

    return { data: response.data || [], totalCount: response?.totalCount ?? 0 };
  };
}

export async function exportToExcel(component: dxDataGrid, fileName = "data", type: "csv" | "xlsx" = "csv") {
  try {
    let filter = component.getCombinedFilter();
    const isSelected = component.getSelectedRowKeys().length > 0;
    component.clearFilter();

    if (!isSelected) {
      component.option("selectedRowKeys", component.getVisibleRows().map(r => r.key));
      component.selectAll();
    }

    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet(fileName);

    await exportDataGrid({
      component,
      worksheet: worksheet,
      selectedRowsOnly: true,
      customizeCell: (options: any) => {
        const { excelCell } = options;

        excelCell.font = {
          name: "Arial",
          family: "Serif"
        };
      }
    });

    const buffer = await workbook[type].writeBuffer();
    saveAs(new Blob([buffer], { type: "application/octet-stream" }), fileName + "." + type);
    // component.filter(filter);
    component.deselectAll();
  } catch (e: any) {
    toast.error(e.toString());
  }
}